/** Framed surface shared by fleet forms, lists, filters and maps. */
export const fleetPanelClassName =
  'rounded-xl border border-border bg-card p-4 text-card-foreground shadow-sm';

/** Same frame without inner padding, for tables and divide-y lists. */
export const fleetTableFrameClassName =
  'overflow-x-auto rounded-xl border border-border bg-card text-card-foreground shadow-sm';
